import { QuestionnaireShell, useQuestionnairePath } from '../common';
import { FormReadOnlyProvider } from '../../common';
import { ConcludeButton } from './components/onboardingQuestionnaireFooter';
import { ONBOARDING_QUESTIONNAIRE_BASE_PATH, ONBOARDING_TAB_CONFIGS, ONBOARDING_TAB_IDS } from './constants';
import {
  useFetchOnboardingDocumentDetails,
  useFetchOnboardingQuestionnaire,
  useInitializeOnboardingTabStatuses,
  useIsOnboardingQuestionnaireReadOnly,
  useOnboardingTabMenuOptions,
} from './hooks';
import { InsuranceExtractionOverwriteConfirmModal } from './components/forms/insurance/components';
import { useInsuranceCardExtractionManager } from './components/forms/insurance/hooks';
import OnboardingQuestionnaireRoutes from './OnboardingQuestionnaireRoutes';

export default function OnboardingQuestionnaire() {
  useInitializeOnboardingTabStatuses();
  useFetchOnboardingDocumentDetails();
  useFetchOnboardingQuestionnaire();
  const { isReadOnly } = useIsOnboardingQuestionnaireReadOnly();
  const { overwriteConfirmationInsuranceType, confirmOverwrite, cancelOverwrite } =
    useInsuranceCardExtractionManager(!isReadOnly);

  const basePath = useQuestionnairePath(ONBOARDING_QUESTIONNAIRE_BASE_PATH, 'onboardingQuestionnaireId');
  const tabOptions = useOnboardingTabMenuOptions(basePath);

  return (
    <FormReadOnlyProvider readOnly={isReadOnly}>
      <QuestionnaireShell
        tabOptions={tabOptions}
        tabsAriaLabel="Onboarding questionnaire sections"
        tabConfigs={ONBOARDING_TAB_CONFIGS}
        basePath={basePath}
        terminalTabId={ONBOARDING_TAB_IDS.SUBMIT}
        terminalAction={<ConcludeButton />}
      >
        <OnboardingQuestionnaireRoutes />
      </QuestionnaireShell>
      {overwriteConfirmationInsuranceType ? (
        <InsuranceExtractionOverwriteConfirmModal
          insuranceType={overwriteConfirmationInsuranceType}
          onClose={cancelOverwrite}
          onSubmit={confirmOverwrite}
        />
      ) : null}
    </FormReadOnlyProvider>
  );
}
